import React, { Component } from "react";
import { Table } from "antd";
import { req_list_lrs_finishByFulltime } from "../../api";
import storageUtils from "../../utils/storageUtils";

export default class FinishByFulltime extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    items: [],
  };

  UNSAFE_componentWillMount() {
    this.api_list_items();
    this.init_columns();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    this.setState({ loading: true });
    const result = await req_list_lrs_finishByFulltime(
      storageUtils.getUser().token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "專兼任分類",
        dataIndex: "timeType",
        width: 60,
      },
      {
        title: "專兼任課程總數",
        dataIndex: "timeTypeTotal",
        width: 30,
        render: (timeTypeTotal) => <>{timeTypeTotal}門</>,
      },
      {
        title: "已完成教材上傳課程數",
        dataIndex: "hasMaterialTotal",
        width: 30,
        render: (hasMaterialTotal) => <>{hasMaterialTotal}門</>,
      },
      {
        title: "完成率",
        dataIndex: "sumTotal",
        width: 65,
        render: (sumTotal) => <>{sumTotal}%</>,
      },
    ];
  };

  ////////////////////////////////////////////////////////////

  render() {
    const { items } = this.state;
    return (
      <>
        <Table
           scroll={{ y: 480 }}
          dataSource={items}
          columns={this.columns}
          pagination={false}
          rowKey="timeType"
        />
      </>
    );
  }
}
